import { route } from './experience/route';
import { dataSources } from './component/data-sources.listener';
import { rentalApiSources } from './experience/rental-api-sources.listener';
import { layoutManager } from './component/layout-manager.listener';
import { experienceSSR } from './experience/experience-ssr';
import { operationsServer } from './experience/operations';
import { customVariables } from './experience/custom-variables';
import { timeouts } from './experience/timeouts';
import { cartListener } from './component/cart.listener';
import { buyboxListener } from './component/buybox.listener';
import { performanceListener } from './component/performance.listener';
import { noResultsListener } from './component/no-results.listener';
import { staticAssets } from './experience/static-assets';

const NewRelicBridge = {
  init: () => {
    if (typeof window === 'undefined') return;
    if (typeof newrelic === 'undefined') return;

    try {
      // reports all api errors
      dataSources();
      rentalApiSources();
      // reports all component errors that failed to layout
      layoutManager();
      customVariables();
      experienceSSR();
      operationsServer();
      timeouts();
      cartListener();
      buyboxListener();
      performanceListener();
      noResultsListener();
      staticAssets();
    } catch (err) {
      console.log(err);
    }

  }
};

export { NewRelicBridge };
